import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from 'modules/home/signin/signin.component';
import { AuthGuard } from 'guards/auth/auth.guard';

const routes: Routes = [
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: '',
    loadChildren: () => import('modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('modules/user/user.module').then(m => m.UserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'signout',
    loadChildren: () => import('modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ticket',
    loadChildren: () => import('modules/ticket/ticket.module').then(m => m.TicketModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ticketattribute',
    loadChildren: () => import('modules/ticket-attribute/ticket-attribute.module').then(m => m.TicketAttributeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ou',
    loadChildren: () => import('modules/organization-units/organization-units.module').then(m => m.OrganizationUnitsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'project',
    loadChildren: () => import('modules/project/project.module').then(m => m.ProjectModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'arcgis',
    loadChildren: () => import('modules/arcgis/arcgis.module').then(m => m.ArcgisModule),
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
